import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {AiOutlineDelete, AiOutlineSortDescending, AiOutlineSortAscending} from "react-icons/ai";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { SiGooglesheets } from "react-icons/si";
import { FaClone, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Loader, Button, Dropdown_Status, Loader2 } from "../../Components";
import { updateProjectStatus } from "../../Redux/actions/projectActions";

const DashboardTable = ({setRenameModal, setProjectCloneModalOpen, seProjectIdForClone, deleteProject}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dateSort, setDateSort] = useState("desc");
  const [pageNo, setPageNo] = useState(1);

  let { projects, totalProjects } = useSelector((state) => state?.projects);

  let projectLoadingInOnePage = window.innerWidth > 2500 ? 15 : 8;
  let totalPages = Math.ceil(totalProjects / projectLoadingInOnePage);
  console.log("Dashboard Table Data =", projects);

  const navigateToProject = (projectId) => {
    navigate(`/dashboard/${projectId}`);
  };

  const handleNavigate = (projectId, isCard) => {  
    navigateToProject(projectId, isCard);    
    localStorage.setItem(
      "isCard",
      JSON.stringify(isCard === true ? true : false)
    );
  };

  const sortByDate = (sortType) => {
    setDateSort(sortType);
    projects = projects.sort((a, b) => {
      if (sortType === "asc")
        return new Date(a.createdAt) - new Date(b.createdAt);
      else return new Date(b.createdAt) - new Date(a.createdAt);
    });
  };

  const increment = () => {
    setPageNo(pageNo < totalPages ? pageNo + 1 : pageNo);
  };

  const decrement = () => {
    setPageNo(pageNo > 1 ? pageNo - 1 : pageNo);
  };

  const [options, setOptions] = useState([
    { label: "No Status", value: "defaultStatusClass" },
    { label: "Approved", value: "approvedClass" },
    { label: "In Progress", value: "inProgressClass" },
    { label: "Need Review", value: "needsReviewClass" },
  ]);

  const handleChangeStatus = (index, value, project_id) => {
    const idx = options.findIndex((opt) => opt.value === value);
    dispatch(updateProjectStatus(project_id, value, idx));
  };

  return (
    <>
      <div className="border-[rgba(255,255,255,.08)] bg-white/[0.02] rounded-[20px] shadow-2xl overflow-hidden" style={{border:'1px solid #ffffff14'}}>

        <div className="p-5 border-b border-[rgba(255,255,255,.06)] flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <h2 className="text-white text-[16px] font-semibold tracking-tight">My Projects</h2>

          <div className="flex items-center gap-3">
            <div className="relative"><input type="search" className="h-9 w-[180px] sm:w-[220px] bg-[rgba(255,255,255,.04)] border border-[rgba(255,255,255,.08)] rounded-lg pl-9 pr-3 text-[13px] text-white placeholder:text-sx-faint focus:outline-none focus:border-sx-violet/50 transition-colors" /></div>
            <select className="h-9 bg-[rgba(255,255,255,.04)] border border-[rgba(255,255,255,.08)] rounded-lg px-3 text-[13px] text-sx-dim focus:outline-none focus:border-sx-violet/50 transition-colors cursor-pointer"></select>
            <select className="h-9 bg-[rgba(255,255,255,.04)] border border-[rgba(255,255,255,.08)] rounded-lg px-3 text-[13px] text-sx-dim focus:outline-none focus:border-sx-violet/50 transition-colors cursor-pointer"></select>
          </div>
        </div>

        <div className="overflow-x-auto ">
          <table className="w-full text-left border-collapse">
            <thead className="">
              <tr className="border-b border-[rgba(255,255,255,.06)] text-[12px] text-sx-faint font-medium px-5">
                <th className="px-5 py-4 font-normal">Sr No</th>
                <th className="px-5 py-4 font-normal">Project</th>
                <th className="px-5 py-4 font-normal">Types</th>
                <th className="px-5 py-4 font-normal">Status</th>
                <th className="px-5 py-4 font-normal">Created</th>
                <th className="px-5 py-4 font-normal">Actions</th>
                <th className="px-5 py-4 font-normal">Edit Project</th>
              </tr>
            </thead>

            <tbody className="">
              {projects && projects?.length ? (projects?.map((project, idx) => {
                  return project ? (
                    <tr className="white-80 h-12 text-lg  hover:bg-[#7c5cff14] border-b border-[rgba(255,255,255,.06)] " key={idx}>

                      <td className="w-[5%]" align="center">
                        <div className="">{idx + 1}</div>
                      </td>

                      <td className="w-[30%]" align="start">
                        <div  className="pl-5 cursor-pointer"  onClick={() => navigateToProject(project?._id)}>
                          {project?.title}
                        </div>
                      </td>

                      <td className="w-[30%]" align="start">
                        <div  className="w-[13%] flex items-center justify-center manrope-600 text-base curson-pointer"  onClick={() =>  handleNavigate(project?._id, project?.isCard)}>
                          <span>{project?.isCard ? "Card" : "Scroll"}</span>
                        </div>
                      </td>

                      <td className="w-[10%]">
                        <div className="">
                          <Dropdown_Status
                            options={options}
                            value={ project?.projectStatus === "" ? "No Status" : project?.projectStatus}
                            projectStatus={project?.projectStatus}
                            selectedID={project?.statusId}
                            onChange={(value) => {handleChangeStatus(idx, value, project?._id);}}
                          />
                        </div>
                      </td>

                      <td className="w-[25%]" align="center">
                        <div className="">
                          {new Date(project?.createdAt).toDateString()} -{" "}
                          {new Date(project?.createdAt).toTimeString().slice(0, 8)}
                        </div>
                      </td>

                      <td className="w-[25%]">
                        <div className="flex w-[23.3%]">
                          <div className="pr-3 edit">
                            <span className="cursor-pointer white-80"
                              onClick={() =>
                                setRenameModal((prev) => ({
                                  ...prev,
                                  isOpen: true,
                                  id: project?._id,
                                  title: project?.title,
                                }))
                              }
                            >
                              <MdOutlineDriveFileRenameOutline />
                            </span>
                          </div>

                          <div className="clone">
                            <div  className="px-3 white-80 cursor-pointer"  onClick={() => { setProjectCloneModalOpen(true);  seProjectIdForClone(project?._id); }}><FaClone /></div>
                          </div>

                          <div className="px-3 sheet">
                            <div className="flex  white-80 text-xl ">
                              {project?.googleSheetLink ? (
                                <span  className="cursor-pointer white-80" onClick={() => window.open(project?.googleSheetLink)}><SiGooglesheets /></span>
                              ) : project?.googleSpreadSheetId ? (
                                <span  className="mx-2 cursor-pointer white-80"  onClick={() => window.open(`https://docs.google.com/spreadsheets/d/${project?.googleSpreadSheetId}`)}><SiGooglesheets /></span>
                              ) : null}
                            </div>
                          </div>

                          <div className="px-3 delete">
                            <span  className=" cursor-pointer white-80"  onClick={() =>  deleteProject(project?._id, project?.title) }><AiOutlineDelete /></span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  );
                })
              ) : (
                <tr>
                  <td colspan="5"><p className="flex justify-center items-center h-[30vh] white-80">No Data Found</p></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {totalProjects > projectLoadingInOnePage && (
          <div className="paginationBox Syne700  select-none text-white flex justify-center gap-[1rem] items-center w-[100%] h-[50px] " style={{ backgroundColor: "#1c1f23" }}>
            <p className="FontFamily-Avenir flex text-sm 3xl:text-base items-center cursor-pointer hover:text-gray-400" onClick={decrement}><FaChevronLeft />prev</p>
            <p className="FontFamily-Avenir text-[0.8rem]">{pageNo} / {totalPages}</p>
            <p className="FontFamily-Avenir flex text-sm 3xl:text-base items-center cursor-pointer hover:text-gray-400" onClick={increment}>next<FaChevronRight /></p>
          </div>
        )}
    </>
  );
};

export default DashboardTable;